import React, { useMemo } from 'react';
import { ListChecksIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
import { TaskItem } from '../tasks/TaskItem';
import { EmptyState } from '../ui/EmptyState';
import { useAppData } from '../../contexts/AppDataContext';
export function UpcomingTasksSection() {
  const {
    tasks,
    toggleTaskCompleted
  } = useAppData();
  const upcoming = useMemo(() => tasks.filter(t => !t.completed).sort((a, b) => new Date(a.deadline).getTime() - new Date(b.deadline).getTime()).slice(0, 4), [tasks]);
  return <section data-id="element-85" data-mp="r9acmsq068pp">
      <SectionHeader icon={ListChecksIcon} iconClassName="bg-indigo-50 text-indigo-600" title="Upcoming tasks" linkTo="/tasks" data-id="element-86" data-mp="r9sd61jp793f" />
      {upcoming.length === 0 ? <EmptyState icon={ListChecksIcon} title="Nothing due" description="You're all caught up." data-id="element-87" data-mp="w5r0dltail29" /> : <div className="space-y-2" data-id="element-88" data-mp="1oo4mio59kili">
          {upcoming.map(task => <TaskItem key={task.id} task={task} onToggleComplete={() => toggleTaskCompleted(task.id)} compact data-id="element-89" data-mp="1oqhabhxpdn6h" />)}
        </div>}
    </section>;
}